
import { cloneDeep } from 'lodash';

import { Component, Input, OnInit, OnChanges, Output, EventEmitter, OnDestroy } from '@angular/core';

import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';

import { FieldTypeListParentService } from '../utils/field-type-list-parent.service';
import { AfTranslateDirective } from '../../../modules/translate/directive/af-translate.directive';
import { TooltipModule } from 'primeng/tooltip';
import { NgClass } from '@angular/common';
import { RegisterMixtapeService } from '@shared/services/register-mixpanel/register-mixtape.service';

@Component({
    selector: 'field-type-list-button',
    templateUrl: './field-type-list-button.component.html',
    standalone: true,
    imports: [NgClass, TooltipModule, AfTranslateDirective]
})
export class FieldTypeListButtonComponent implements OnInit, OnChanges {
  selectionAsArray:boolean = false;
  isLanding = this.customLanding.isLanding();
  skin:string = this.globalCfg.skin;
  fieldTypeList:any = this.fieldTypeListParent.configureFieldTypeList(this);

  constructor( private globalCfg: GlobalCfgFactory,
    private customLanding: CustomLandingFactory,
    private registerService: RegisterMixtapeService,
    private fieldTypeListParent: FieldTypeListParentService) {
  }

  @Input() field:any = null;
  @Input() preSelectItem:any = '';
  @Input() listValues:any = [];
  @Input() listAll:any = [];
  @Input() public: boolean = false;;
  @Input() type:any = '';
  @Input() orderBy:any;
  @Output() itemSelected = new EventEmitter();
  @Output() openRelatedInfo = new EventEmitter();

  ngOnInit(){
    this.configureButtonType();
  }

  ngOnChanges(): void {
    this.fieldTypeListParent.configureChanges(this);
  }

  configureButtonType(){
    if (this.field){
      if(this.skin == 'icam-red' && this.field.iD_Version0 == 10){
        let newListValue: any = [
          this.listValues[0],
          this.listValues[1],
          this.listValues[2],
        ];
        if(this.isLanding){
          newListValue = [
            this.listValues[0],
            this.listValues[3],
            this.listValues[2],
            this.listValues[1],
          ]
        }
        this.listValues = cloneDeep(newListValue);
      }

      for(let i=0; i<this.listValues.length;i++){
        if(this.listValues[i].selected){
          this.fieldTypeList.selectItemId = this.listValues[i].listValueId;
          this.itemSelected.emit({newValue: this.listValues[i].listValueId});
          this.fieldTypeList.showLessInfo = true;
        }
      }
    }
  }

  selectedButtonField(listValue:any){
    if (listValue.numOrder < 4) {
      if (!this.field.noEditable) {
        this.listValues.forEach((value:any) => {
          value.selected = false;
          if(value.listValueId === listValue.listValueId && this.fieldTypeList.selectItemId !== listValue.listValueId){
              value.selected = true;
              this.fieldTypeList.showLessInfo = true;
              this.fieldTypeList.selectItemId = value.listValueId;
              this.field.error = false;
              this.itemSelected.emit({ newValue: value.listValueId });
          }else if(value.listValueId === listValue.listValueId && this.fieldTypeList.selectItemId === listValue.listValueId){
              this.fieldTypeList.selectItemId = '';
              this.fieldTypeList.showLessInfo = false;
              this.itemSelected.emit({ newValue: null });
          }
        });
      }
    }else{
      let resgisterItem : any ={
        clientId: '76863',
        event: 'enlace externo ICAM',
        centinelaProduct: 'icam'
      }
      this.registerService.register(resgisterItem);
      window.open('https://biblioteca.icam.es/consultas-juridicas/', '_blank');
    }
  }
}
